// extracted by mini-css-extract-plugin
export default {"container":"StatCardsParent_container__vt45i","title":"StatCardsParent_title__Gnt06","grid":"StatCardsParent_grid__XSl+9"};